import {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const SignUpRewardsHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.funding;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'FundingHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return (
    <HistoryComponent historyfilter={filterTypes.signupRewards} {...props} />
  );
};

export default SignUpRewardsHistoryList;
